import styled from "styled-components";
import homeBanner from "src/assets/home-banner.webp";
import { Typography } from "antd";
import type { CSSProperties } from "react";

export const BannerSection = styled("section")({
  position: "relative",
  width: "100%",
  background: `center / cover no-repeat url(${homeBanner})`,
  height: "500px",
  overflow: "hidden",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "white",
});

export const HeroSection = styled("section")({
  position: "relative",
  width: "100%",
  overflow: "hidden",
});

export const SearchContainer = styled("div")({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  gap: 8,
  backgroundColor: "white",
  borderRadius: 60,
  padding: "8px 8px 8px 24px",
  boxShadow: "0 20px 60px rgba(108, 92, 231, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.05)",
  maxWidth: 900,
  width: "100%",
  "@media (max-width: 768px)": {
    borderRadius: 16,
    padding: 16,
  },
});

export const TrustSection = styled("section")({
  padding: "64px 20px",
  borderTop: "1px solid #f0f0f0",
  borderBottom: "1px solid #f0f0f0",
  background: "white",
});

export const AdvantageCard = styled("div")({
  display: "flex",
  gap: 16,
  alignItems: "flex-start",
});

export const FinalCTASection = styled("div")({
  background: "linear-gradient(135deg, #0a0f1a 0%, #1a1f2e 50%, #2a2f3e 100%)",
  borderRadius: 48,
  padding: "80px 40px",
  margin: "0 40px",
  position: "relative",
  overflow: "hidden",
  "@media (max-width: 768px)": {
    padding: "60px 24px",
    borderRadius: 32,
    margin: "0 16px",
  },
});

export const BannerContent = styled("div")({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  justifyContent: "space-around",
  width: "100%",
  height: "100%",
  padding: "0 20px",
});

export const Title = styled("h1")({
  flex: "1 1 50%",
  fontSize: "50px",
  lineHeight: 1.3,
  fontWeight: 700,
  maxWidth: "400px",
});

export const SearchBox = styled("div")({
  flex: "1 1 50%",
  display: "flex",
  maxWidth: "450px",
  alignItems: "center",
  background: "white",
  borderRadius: "30px",
  padding: "6px 12px",
  gap: "8px",
});

export const SearchInput = styled("input")({
  border: "none",
  outline: "none",
  padding: "10px 8px",
  fontSize: "16px",
  borderRadius: "30px",
  width: "100%",
});

export const SearchIcon = styled("span")(({ theme }) => ({
  color: theme.colorPrimary,
  fontSize: "20px",
}));

export const CategoriesGrid = styled("div")({
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
  justifyItems: "center",
  gap: "40px",
  padding: "0 40px 60px",
  maxWidth: "1300px",
  margin: "0 auto",
});

export const CategoryGroup = styled("div")({
  width: "180px",
});

export const CategoryTitle = styled("h3")(({ theme }) => ({
  fontSize: "20px",
  fontWeight: 600,
  color: theme.colorPrimary,
  margin: "16px 0 24px",
}));

export const CategoryIcon = styled("div")(({ theme }) => ({
  fontSize: "24px",
  color: theme.colorPrimary,
}));

export const CategoryItems = styled("ul")({
  listStyle: "none",
  padding: 0,
  margin: 0,
});

export const CategoryItem = styled("li")({
  fontSize: "16px",
  fontWeight: 500,
  color: "#444",
  margin: "4px 0 10px",
});

export const AppPromo = styled("section")({
  textAlign: "center",
  margin: "60px auto 80px",
});

export const AppText = styled("h3")({
  fontSize: "22px",
  color: "#333",
  marginBottom: "16px",
});

export const QrPlaceholder = styled("div")({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  width: "120px",
  height: "120px",
  background: "#f0f0f0",
  border: "2px dashed #ccc",
  borderRadius: "8px",
  marginTop: "8px",
});

export const QrcodeStyled = styled("span")({
  fontSize: "40px",
  color: "#888",
});

//

export const Section = styled("section")<{ color?: "default" | "paper" | "primary"; rounded?: boolean }>(
  ({ color = "default", rounded = false }) => ({
    backgroundColor:
      color === "default" ? "rgb(246, 248, 252)" : color === "primary" ? "rgb(80, 70, 229)" : "rgb(255, 255, 255)",
    padding: "48px 20px",
    borderRadius: rounded ? 16 : 0,
  }),
);

export const SectionContentWrapper = styled("div")(({ theme }) => ({
  margin: "0 auto",
  maxWidth: theme.screenXL,
}));

export const SectionTitle = styled(Typography.Title)<{ align?: CSSProperties["textAlign"] }>(
  ({ align = "center" }) => ({
    textAlign: align,
    fontWeight: 700,
  }),
);
